@if (attachments.length > 1) {
  <div class="document-preview__picker">
    @for (a of attachments; track a.href; let i = $index) {
      <button
        type="button"
        class="document-preview__picker-item"
        [class.document-preview__picker-item--active]="i === activeIndex"
        (click)="selectAttachment(i)">
        {{ a.fileName }}
      </button>
    }
  </div>
}
@if (attachment) {
  @switch (kind) {
    @case ('pdf') {
      @if (resolvedUrl) {
        <ngx-extended-pdf-viewer
          [src]="resolvedUrl"
          [height]="'100%'"
          [backgroundColor]="'#eee'"
          [showToolbar]="true"
          [showSidebarButton]="false"
          [showOpenFileButton]="false"
          [showDownloadButton]="false"
          [showSecondaryToolbarButton]="false">
        </ngx-extended-pdf-viewer>
      } @else if (error) {
        <div class="document-preview__error">Voorbeeld laden mislukt.</div>
      } @else {
        <div class="document-preview__loading">Laden...</div>
      }
    }
    @case ('image') {
      @if (resolvedUrl) {
        <img class="document-preview__image" [src]="resolvedUrl" [alt]="attachment.fileName">
      } @else if (error) {
        <div class="document-preview__error">Voorbeeld laden mislukt.</div>
      } @else {
        <div class="document-preview__loading">Laden...</div>
      }
    }
    @default {
      <div class="document-preview__unsupported">
        <span>Geen voorbeeld beschikbaar voor "{{ attachment.fileName }}".</span>
        <button type="button" class="btn btn--basic" (click)="download()">Downloaden</button>
      </div>
    }
  }
}
